import { Injectable } from '@angular/core';

@Injectable()
export class AddressService {
  public address: any;

  setAddress(address) {
    this.address = address;
  }

  getAddress() {
    return this.address;
  }
}
